import SwalConfig from "@/swalConfig";
import classnames from "classnames";

import { green } from "./constants/colors";

const successAlert = (title, timer, classes) => {
  return SwalConfig({
    html: `<div class=${classes.swalContainer}><p class=${classes.description}>
    ${title}</p></div>`,
    showCancelButton: false,
    confirmButtonText: "Okay",
    buttonsStyling: false,
    customClass: {
      confirmButton: classnames(classes.button, classes.swalConfirmButton),
      popup: classnames(classes.popup),
      actions: classnames(classes.actions),
      content: classnames(classes.content),
    },
    timer: timer || 1500,
  });
};

const failAlert = (title, body, redirect, timer) => {
  return SwalConfig({
    position: "center",
    title: `<strong style="color:"${green}"; font-size:1.2rem">${title}!!</strong>`,
    html: `<p>${body || ""}</p>`,
    confirmButtonColor: green,
    showConfirmButton: true,
    timer: timer || 1500,
  }).then(() => (redirect ? redirect() : null));
};
export { successAlert, failAlert };
